(function() {

	window.TJ_DB = {
		// 本地数据库名
		DB_Name: 'IMDB',
		// 会话列表表名
		C_Table: 'conversationTable',
		// 消息列表表名
		M_Table: 'msgTable',
		// 旺旺订单表
		ORDER_Table: 'orderTable',
		// 旺旺客户信息表
		WWUSERINFO_Table: 'wwUserInfoTable',
		// websocket日志表名
		WSLOG_Table: 'wsLogTable',

		// 打开本地数据库
		openDB: function (callback) {
			var self = this;

			// self.DB_Name += +new Date();
			var indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.msIndexedDB,
				request = indexedDB.open(self.DB_Name, 1);

			request.onerror = function (e) {
				console.log('打开数据库失败:' + e.target.message);
			}
			request.onsuccess = function (e) {
				self.DB = e.target.result;
				if (callback && typeof callback == 'function') callback();
			}
			request.onupgradeneeded = function(e) {
				self.DB = e.target.result;
				// 创建 会话列表 存储表
				if (!self.DB.objectStoreNames.contains(self.C_Table)) {
					var objectStore = self.DB.createObjectStore(self.C_Table, {
						keyPath: 'id'
					});
					// 指定可以被索引的字段(unique表示字段值是否唯一)
					objectStore.createIndex('shopId', 'shopId', {
						unique: false
					});
					objectStore.createIndex('unreply', 'unreply', {
						unique: false
					});
					objectStore.createIndex('unread', 'unread', {
						unique: false
					});
				}
				// 创建 消息列表 存储表
				if (!self.DB.objectStoreNames.contains(self.M_Table)) {
					var objectStore = self.DB.createObjectStore(self.M_Table, {
						keyPath: 'createKey',
						autoIncrement: true
					});
					objectStore.createIndex('sessionid', 'sessionid', {
						unique: false
					});
					objectStore.createIndex('uuid', 'uuid', {
						unique: false
					});
				}
				// 创建 旺旺订单 存储表
				if (!self.DB.objectStoreNames.contains(self.ORDER_Table)) {
					var objectStore = self.DB.createObjectStore(self.ORDER_Table, {
						keyPath: 'newKey' // newKey为 kehuId 加 - 加 shopId 拼接而成，如 xinxiyi2009-5320
					});
				}
				// 创建 旺旺客户信息 存储表
				if (!self.DB.objectStoreNames.contains(self.WWUSERINFO_Table)) {
					var objectStore = self.DB.createObjectStore(self.WWUSERINFO_Table, {
						keyPath: 'kehuId'
					});
				}
				// 创建 websocket记录 存储表
				if (!self.DB.objectStoreNames.contains(self.WSLOG_Table)) {
					var objectStore = self.DB.createObjectStore(self.WSLOG_Table, {
						keyPath: 'indexedDBCreateTime'
					});
				}
				console.log('数据库版本号有变化！');
			}
			request.onblocked = function(e) {
				// 如果用户已经在一个标签页中打开了你的应用的旧版本的数据库，然后他又在另一个标签页中加载了你的应用的新版本，这种情况下会触发blocked事件。当你带着比数据库实际版本更高的版本号调用 open() 时，所有其他打开的数据库必须在你开始实际对数据库进行修改之前显式通知这个请求。
				console.log('Please close all other tabs with this site open!');
			}
		},

		// 向本地数据库添加数据，返回值：{success: 成功个数, error: 失败个数, lastKey: 最后一个的索引值}
		add: function (tableName, data, callback) {
			if (!this.DB) return;

			var self = this,
				length = 0,
				error = 0,
				lastKey = '',
				transaction = self.DB.transaction([tableName], 'readwrite'),
				store = transaction.objectStore(tableName);

			if (data.length === undefined) data = [data];

			if (data.length === 0) {
				if (callback && typeof callback == 'function') {
					callback({ success: 0, error: 0, lastKey: null });
				}
				return
			}

			for (var i in data) {
				try {
					data[i].indexedDBCreateTime = +new Date();

					if (tableName == self.C_Table) {
						if (data[i].indexedDBUpdateMsgTime) {
						} else if (data[i].unreply) {
							data[i].indexedDBUpdateMsgTime = data[i].lastMsgTime ? (+new Date(data[i].lastMsgTime)) : (+new Date());
						} else {
							data[i].indexedDBUpdateMsgTime = +new Date() + 30*24*60*60*1000;
						}
					}
				} catch (e) {
				}
				var request = store.add(data[i]);
				request.onsuccess = function (e) {
					length++;
					lastKey = e.target.result;
					if (length >= data.length && callback && typeof callback == 'function') {
						callback({
							success: data.length - error,
							error: error,
							lastKey: lastKey
						});
					}
				};
				request.onerror = function () {
					length++;
					error++;
					console.error('本地数据库写入失败。tableName: ' + tableName + ', data: ', data)
					if (length >= data.length && callback && typeof callback == 'function') {
						callback({
							success: data.length - error,
							error: error,
							lastKey: lastKey
						});
					}
				}
			}
		},

		// 删除本地数据库数据
		del: function (tableName, where, callback) {
			if (!this.DB) return;
			
			var self = this;

			self.where(tableName, where, function(result) {
				var transaction = self.DB.transaction([tableName], 'readwrite'),
					store = transaction.objectStore(tableName),
					data = result.keyArr,
					length = 0,
					error = 0;

				if (!data.length) {
					if (callback && typeof callback == 'function') {
						callback({status: true});
					}
					return;
				}

				for (var i in data) {
					var objectStoreRequest = store.delete(data[i]);
					objectStoreRequest.onsuccess = function() {
						length++;
						if (length >= data.length && callback && typeof callback == 'function') {
							callback({status: !error});
							// if (error) transaction.abort();
						}
					};
					objectStoreRequest.onerror = function() {
						length++;
						error++;
						if (length >= data.length && callback && typeof callback == 'function') {
							callback({status: !error});
							// if (error) transaction.abort();
						}
					};
				}
			});
		},

		// 更新本地数据库数据
		edit: function (tableName, key, data, successCallback, errorCallback) {
			if (!this.DB) return;
			var self = this,
				store = self.DB.transaction([tableName], 'readwrite').objectStore(tableName),
				objectStoreRequest = store.get(key);

			objectStoreRequest.onsuccess = function(e) {
				var myRecord = e.target.result;
				if (myRecord) {
					for (var k in data) {
						if (typeof data[k] == 'object') {
							for (var j in data[k]) {
								if (!myRecord[k]) myRecord[k] = {};
								myRecord[k][j] = data[k][j];
							}
						} else {
							myRecord[k] = data[k];
						}
					}
					var request = store.put(myRecord);
					request.onsuccess = function(e) {
						if(successCallback && typeof successCallback == 'function') successCallback();
					}
					request.onerror = function(e) {
						if(errorCallback && typeof errorCallback == 'function') errorCallback(e.target.error);
					}
				} else {
					if(errorCallback && typeof errorCallback == 'function') errorCallback(e.target.error);
				}
			}
		},

		// 获取本地数据库数据
		get: function (tableName, where, callback) {
			if (!this.DB) return;
			var self = this;

			self.where(tableName, where, function(result) {
				if (tableName == self.C_Table) {
					if (sortType == 'startTime') {
						result.resultArr.sort(function(a, b) {
							return b.indexedDBCreateTime - a.indexedDBCreateTime;
						});
					} else {
						result.resultArr.sort(function(a, b) {
							return a.indexedDBUpdateMsgTime - b.indexedDBUpdateMsgTime;
						});
					}
					
					var arr1 = [], arr2 = [];
					for (var i = 0; i < result.resultArr.length; i++) {
						result.resultArr[i].uncloseable ? arr1.push(result.resultArr[i]) : arr2.push(result.resultArr[i]);
					}
					result.resultArr = arr1.concat(arr2);
				}
				if(callback && typeof callback == 'function') callback(result.resultArr);
			});
		},

		// 查询条件处理
		where: function(tableName, where, callback) {
			var self = this,
				store = self.DB.transaction([tableName], 'readonly').objectStore(tableName),
				whereArr = (where == 1 || where === true) ? [1] : where.split('||'),
				resultArr = [],
				keyArr = [],
				num = 0;

			if (where == 1 || where === true) {
				var request = store.getAll();
				request.onsuccess = function(e){
					var rArr = e.target.result;
					for (var j = 0; j < rArr.length; j ++) {
						var result = rArr[j];
						resultArr.push(result);
						keyArr.push(result[store.keyPath]);
					}
					judge();
				}
				request.onerror = function(e){
					judge();
				}
				return;
			}

			for (var i = 0; i < whereArr.length; i++) {
				var tempArr = whereArr[i].split('&&');
				whereArr[i] = [];

				for (var j = 0; j < tempArr.length; j++) {
					var obj = {},
						condition = tempArr[j];
					if (condition.indexOf('==') != -1) {
						var temp = condition.split('=='),
							initV = temp[1].trim(),
							v = initV.replace(/^(\'|\")|(\'|\")$/g, '');
						if (!(/^(\'|\").*(\'|\")$/.test(initV)) && !isNaN(v)) v = v*1;
						obj = {
							field: temp[0].trim().replace(/\'|\"/g, ''),
							val: v,
							sign: '=='
						}

					} else if (condition.indexOf('>=') != -1) {
						var temp = condition.split('>='),
							initV = temp[1].trim(),
							v = initV.replace(/^(\'|\")|(\'|\")$/g, '');
						if (!(/^(\'|\").*(\'|\")$/.test(initV)) && !isNaN(v)) v = v*1;
						obj = {
							field: temp[0].trim().replace(/\'|\"/g, ''),
							val: v,
							sign: '>='
						}

					} else if (condition.indexOf('>') != -1) {
						var temp = condition.split('>'),
							initV = temp[1].trim(),
							v = initV.replace(/^(\'|\")|(\'|\")$/g, '');
						if (!(/^(\'|\").*(\'|\")$/.test(initV)) && !isNaN(v)) v = v*1;
						obj = {
							field: temp[0].trim().replace(/\'|\"/g, ''),
							val: v,
							sign: '>'
						}

					} else if (condition.indexOf('<=') != -1) {
						var temp = condition.split('<='),
							initV = temp[1].trim(),
							v = initV.replace(/^(\'|\")|(\'|\")$/g, '');
						if (!(/^(\'|\").*(\'|\")$/.test(initV)) && !isNaN(v)) v = v*1;
						obj = {
							field: temp[0].trim().replace(/\'|\"/g, ''),
							val: v,
							sign: '<='
						}

					} else if (condition.indexOf('<') != -1) {
						var temp = condition.split('<'),
							initV = temp[1].trim(),
							v = initV.replace(/^(\'|\")|(\'|\")$/g, '');
						if (!(/^(\'|\").*(\'|\")$/.test(initV)) && !isNaN(v)) v = v*1;
						obj = {
							field: temp[0].trim().replace(/\'|\"/g, ''),
							val: v,
							sign: '<'
						}

					} else if (condition.indexOf('!=') != -1) {
						var temp = condition.split('!='),
							initV = temp[1].trim(),
							v = initV.replace(/^(\'|\")|(\'|\")$/g, '');
						if (!(/^(\'|\").*(\'|\")$/.test(initV)) && !isNaN(v)) v = v*1;
						obj = {
							field: temp[0].trim().replace(/\'|\"/g, ''),
							val: v,
							sign: '!='
						}

					}
					if (obj == {}) continue;
					((j + 1) == tempArr.length && obj.field == store.keyPath) ? whereArr[i].push(obj) : whereArr[i].unshift(obj);
				}
			}

			for (var i = 0; i < whereArr.length; i++) {
				var thisArr = whereArr[i],
					field = thisArr[0].field,
					sign = thisArr[0].sign,
					val = thisArr[0].val,
					tempResultArr = [],
					tempKeyArr = [];

				if (field == store.keyPath) {
					if (sign == '==') {
						var request = store.get(val);
						request.onsuccess = function(e){
							var result = e.target.result;
							if (result) {
								resultArr.push(result);
								keyArr.push(val);
							}
							judge();
						}
						request.onerror = function(e){
							judge();
						}
					} else {
						var request = store.getAll();
						request.onsuccess = function(e){
							var rArr = e.target.result;
							for (var j = 0; j < rArr.length; j ++) {
								var result = rArr[j];

								if (contrast(result[field], sign, val)) {
									resultArr.push(result);
									keyArr.push(result[field]);
								}
							}
							judge();
						}
						request.onerror = function(e){
							judge();
						}
					}
				} else {
					try {
						var index = store.index(field),
							request;

						if (sign == '==') {
							request = index.openCursor(IDBKeyRange.only(val));
						} else if (sign == '>=') {
							request = index.openCursor(IDBKeyRange.lowerBound(val, false));
						} else if (sign == '>') {
							request = index.openCursor(IDBKeyRange.lowerBound(val, true));
						} else if (sign == '<=') {
							request = index.openCursor(IDBKeyRange.upperBound(val, false));
						} else if (sign == '<') {
							request = index.openCursor(IDBKeyRange.upperBound(val, true));
						} else if (sign == '!=') {
							thisArr.push({
								field: field,
								sign: '!=',
								val: val
							});
							request = index.openCursor();
						}

						request.onsuccess = function(e){
							var cursor = e.target.result;

							if (cursor) {
								var data = cursor.value,
									e = false;
								for (var j = 1; j < thisArr.length; j ++) {
									if (!contrast(data[thisArr[j].field], thisArr[j].sign, thisArr[j].val)) {
										e = true;
										break;
									}
								}
								if (!e) {
									tempResultArr.push(data);
									tempKeyArr.push(data[store.keyPath]);
								}
								cursor.continue();
							} else {
								// 游标遍历完了，返回结果
								resultArr = resultArr.concat(tempResultArr);
								keyArr = keyArr.concat(tempKeyArr);
								judge();
							}
						};
						request.onerroe = function(e){
							judge();
						};
					} catch(e) {
						judge();
					}
				}
			}

			function judge() {
				num++;
				if(num >= whereArr.length && callback && typeof callback == 'function') {
					callback({
						keyArr: keyArr,
						resultArr: resultArr
					});
				}
			}

			function contrast (val1, sign, val2) {
				var result = null;

				if (sign == '==') {
					result = (val1 == val2);
				} else if (sign == '>=') {
					result = (val1 >= val2);
				} else if (sign == '>') {
					result = (val1 > val2);
				} else if (sign == '<=') {
					result = (val1 <= val2);
				} else if (sign == '<') {
					result = (val1 < val2);
				} else if (sign == '!=') {
					result = (val1 != val2);
				} else {
					result = false;
				}
				return result;
			}
		}
	}
})();


// WEBPACK FOOTER //
// ./src/assets/scripts/TJ_DB.js